/* For page templates only */

  // Set up options for the fetch request
  var header_options_b2bs = {
    method: 'GET',
    headers: {
      "Authorization": Authorization,
      "Accept": "application/vnd.api+json",
    }    
  };

  /* For Partner page */
  if ($('body').is('.page--hauptpartner, .page--fcsg-partner, .page--medical-and-health-partner, .page--medien-partner, .page--gastronomie, .page--duale-ausbildung, .page--fcsg-supporter'))  {
    let customerGroupId = 15,
        crmTagId = 19,
        isActive = 1,
        html_container = '',
        parent_class = 'partner_contents_with_logo',
        html_type = 'html';
    
    if ($('body').hasClass('page--hauptpartner')) {
      customerGroupId = 18;
      crmTagId = 13;
      html_container = '.contentBuilder_v2_content #i05f.gjs-row .gjs-cell';      
      html_type = 'append';    

      function applyAllCrmTagIds(customerGroupId, html_container) {
          const crmTagIds = [
              { category: "Hauptsponsor", crmTagId: 20 },
              { category: "Naming Right", crmTagId: 21 },
              { category: "Premium Sponsoren", crmTagId: 22 },
              { category: "Platin Sponsoren", crmTagId: 23 },
              { category: "Gold Sponsoren", crmTagId: 24 },
              { category: "Silber Sponsoren", crmTagId: 25 }
          ];         

          crmTagIds.forEach((item, index) => {
              const { category, crmTagId } = item;              
              //console.log(`Index: ${index}, Applying for category: ${category} with crmTagId: ${crmTagId}`);              
              const partner_heading_html = `<h2 class="partner_heading h2">${category}</h2>`;              
              get_partners(customerGroupId, crmTagId, html_container, partner_heading_html, index);
          });
      }      
      
      applyAllCrmTagIds(customerGroupId, html_container); 
      
    } else if ($('body').hasClass('page--fcsg-partner')) {
      customerGroupId = 15;
      crmTagId = 60;
      html_container = '.page--fcsg-partner .fcsg-partner-sec .fcsg-partner-row';
      parent_class = '';
      get_partners(customerGroupId,crmTagId,html_container)
    }else if ($('body').hasClass('page--medical-and-health-partner')) {
      customerGroupId = 17;
      crmTagId = 60;
      html_container = '.page--medical-and-health-partner .contentBuilder_v2_content #i05f.gjs-row .gjs-cell';
      get_partners(customerGroupId,crmTagId,html_container)
    }else if ($('body').hasClass('page--medien-partner')) {
      customerGroupId = 16;
      crmTagId = 60;
      html_container = '.page--medien-partner .contentBuilder_v2_content #i05f.gjs-row .gjs-cell';
      get_partners(customerGroupId,crmTagId,html_container)
    }
    else if ($('body').hasClass('page--fcsg-supporter')) {
      customerGroupId = 41;
      crmTagId = 60;
      html_container = '.page--fcsg-supporter .contentBuilder_v2_content #i05f.gjs-row .gjs-cell';
      get_partners(customerGroupId,crmTagId,html_container)
    }
    if ($('body').hasClass('page--gastronomie')) {
      customerGroupId = 20; //Lieferpartner
      crmTagId = 13;
      html_container = '.page--gastronomie .contentBuilder_v2_content #ipzvt.gjs-row .gjs-cell';
      get_partners(customerGroupId,crmTagId,html_container);      
    }
    if ($('body').hasClass('page--duale-ausbildung')) {
      customerGroupId = 23;
      crmTagId = 44;
      parent_class = 'fcsg-partner-row';
      html_container = '.page--duale-ausbildung .contentBuilder_v2_content #imwqm.gjs-row .gjs-cell';
      get_partners(customerGroupId,crmTagId,html_container);      
    }
    
    function get_partners(customerGroupId,crmTagId,html_container,partner_heading_html,index){
      var filter_crmTagId = '';
      var filter_crmSort = '';
      
      if(crmTagId){
        filter_crmTagId = "&filter[crmTag.id][]="+crmTagId+"";
      }
      
      if(customerGroupId){
        filter_crmSort = "filter[crmSort][]="+customerGroupId;

        if(crmTagId){
         filter_crmSort = "filter[crmSort][]="+customerGroupId+","+crmTagId+"";
        }
      }

      let URL = ''+API_URL+'b2bs?'+filter_crmSort+'';
      //let URL = ''+API_URL+'b2bs?filter[customerGroupId]='+customerGroupId+''+filter_crmTagId+'';
     
      fetch(URL, header_options_b2bs)
        .then(response => {      
          // Parse the response as JSON
          return response.json();
        })
        .then(data => {
          // Handle the JSON data      
          var response_data = data.data;
          // console.log(response_data);
          var html = '';            
          if(response_data != null && response_data != '' ){ 

           if(partner_heading_html){
              html += `<div class="partner_crm_wrap" data-crmID="${crmTagId}" style="order:${index};">`;
              html += partner_heading_html;
              html += `<div class="partner_contents ${parent_class}">`;
            }
            
            for (var c = 0; c < response_data.length; c++) {
              var attributes = response_data[c].attributes;
              let company = attributes.company;
              let company_firstLetter = company.charAt(0).toLowerCase();
              let image = '';
              let website = attributes.website;              
              var address_html = '',
                  beschreibung = '';
             
              if(!isNaN(company_firstLetter)){
                company_firstLetter = 'a'
              }
              
              if(attributes.crmAddresses.length > 0){
                 var crmAddresses = attributes.crmAddresses[0].address;
                 let address_email = crmAddresses.email;
                 if(address_email){
                   address_email = address_email.replace("[at]", "@");
                   address_email = address_email.replace("(at)", "@");
                 }                 
                 address_html += `${crmAddresses.addressLine1 ? `<p class="addressLine1">${crmAddresses.addressLine1}</p>`: "" }
                 ${crmAddresses.addressLine2 ? `<p class="addressLine2">${crmAddresses.addressLine2}</p>`: "" }
                 ${crmAddresses.zipCode || crmAddresses.city ? `<p class="zipCode">${crmAddresses.zipCode ? `${crmAddresses.zipCode}` : "" } ${crmAddresses.city ? `${crmAddresses.city}` : "" }</p>`: "" }
                 ${crmAddresses.phone ? `<p class="phone"><a href="tel:${crmAddresses.phone}">${crmAddresses.phone}</a></p>`: "" }
                 ${crmAddresses.email ? `<p class="email"><a href="mailto:${address_email}">${crmAddresses.email}</a></p>`: "" }
                 `;
              }

              //console.log('currentLang',currentLang);
              
              if(attributes.customFields.length > 0){
                 for (var b = 0; b < attributes.customFields.length; b++) {
                   var customFields = attributes.customFields[b];
                   if(customFields.name == 'Beschreibung' && customFields.locale == 'de_CH'){
                      beschreibung = customFields.value;
                   }
                   if(parent_class == 'fcsg-partner-row'){
                     if(customFields.name == 'Mögliche Berufe:' && customFields.value != null && customFields.locale == 'de_CH'){
                       beschreibung = '<strong>Mögliche Berufe: </strong>'+customFields.value
                     }
                   }
                 }
              }

              let customerDocuments = attributes.customerDocuments;
              if(customerDocuments.length > 0){
                var document1 = customerDocuments.find(function(item) {
                    return item.documentNumber === "1";
                });
              }

              image = attributes.image;
              if($('body').hasClass('page--gastronomie')){
              if(document1){
                  image = document1.document;
                } 
              }
              
              html += `
                <div class="gjs-cell-item row-item" data-sort="${company_firstLetter}">
                <div class="img-col">
                ${image != null && image != ''?`<img alt="${company}" src="${image}">`:`<svg class="placeholder-svg placeholder" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 525.5 525.5"></svg>`}
                </div>
                <div class="content-col">
                ${company != null && company != ''?`<h2 class="title">${company}</h2>`:''}
                ${beschreibung?`<p class="description">${beschreibung}</p>`:''}                  
                ${$('body').hasClass('page--fcsg-partner') ? `<div class="address">${address_html}</div>` : ''}
                ${website != null && website != ''?`<a href="${website}" target="_blank" class="link">Zur Webseite</a>`:''}
                </div>
                </div>
               `;
            }  
           
            $(html_container).addClass(parent_class);
            
            if(partner_heading_html){
              html += `</div></div>`; 
              $(html_container).append(html);
              
              /*
              // Select all containers that need sorting
              var $containers = $('.partner_crm_wrap .partner_contents');
              
              $containers.each(function () {
                  var $container = $(this); // Current container
              
                  // Get all the child elements with the 'gjs-cell-item row-item' class
                  var $items = $container.children('.gjs-cell-item.row-item');
              
                  // Sort the items based on the 'data-sort' attribute
                  var sortedItems = $items.sort(function (a, b) {
                      var sortA = $(a).data('sort'); // Get 'data-sort' value for the first element
                      var sortB = $(b).data('sort'); // Get 'data-sort' value for the second element
                      return sortA.localeCompare(sortB); // Compare alphabetically
                  });
              
                  // Append the sorted items back into the current container
                  $container.append(sortedItems);
              });*/
              
            }            
            else {              
              $(html_container).html(html);

              /*var $container = $(html_container);
              // Get all the child elements with the 'gjs-cell-item row-item' class
              var $items = $container.children('.gjs-cell-item.row-item');
            
              // Sort the items based on the 'data-sort' attribute
              var sortedItems = $items.sort(function (a, b) {
                var sortA = $(a).data('sort'); // Get 'data-sort' value for the first element
                var sortB = $(b).data('sort'); // Get 'data-sort' value for the second element
                return sortA.localeCompare(sortB); // Compare alphabetically
              });
              
              // Append the sorted items back into the container
              $container.append(sortedItems); */
              
            }
            
            
            if ($('body').hasClass('page--gastronomie')) {             
              $('.page--gastronomie .contentBuilder_v2_content .sponsor-grid').addClass('loaded');
            }

            $(html_container).find('.loader_wrap').remove();
            $(html_container).addClass('loaded');
            
          }
          else {
            $(html_container).find('.loader_wrap').remove();
            $(html_container).html('<p>Sie haben keine Partner.</p>');
          }
         
        })
        .catch(error => {
          console.log('error',error);
          // Handle any errors that occurred during the fetch
          html = `<div class="page-data">
              <div class="error-container">
              <h2 class="header">${error}</h2>
              <div class="instructions">
                  <h2>Entschuldigung! Etwas lief schief bei uns. Wir versuchen derzeit, das Problem zu beheben.</h2>
                  <p>In der Zwischenzeit können Sie:</p>
                  <div class="step">
                      <svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 489.711 489.711">
                          <path d="M112.156,97.111c72.3-65.4,180.5-66.4,253.8-6.7l-58.1,2.2c-7.5,0.3-13.3,6.5-13,14c0.3,7.3,6.3,13,13.5,13    c0.2,0,0.3,0,0.5,0l89.2-3.3c7.3-0.3,13-6.2,13-13.5v-1c0-0.2,0-0.3,0-0.5v-0.1l0,0l-3.3-88.2c-0.3-7.5-6.6-13.3-14-13    c-7.5,0.3-13.3,6.5-13,14l2.1,55.3c-36.3-29.7-81-46.9-128.8-49.3c-59.2-3-116.1,17.3-160,57.1c-60.4,54.7-86,137.9-66.8,217.1    c1.5,6.2,7,10.3,13.1,10.3c1.1,0,2.1-0.1,3.2-0.4c7.2-1.8,11.7-9.1,9.9-16.3C36.656,218.211,59.056,145.111,112.156,97.111z"></path>
                      <path d="M462.456,195.511c-1.8-7.2-9.1-11.7-16.3-9.9c-7.2,1.8-11.7,9.1-9.9,16.3c16.9,69.6-5.6,142.7-58.7,190.7    c-37.3,33.7-84.1,50.3-130.7,50.3c-44.5,0-88.9-15.1-124.7-44.9l58.8-5.3c7.4-0.7,12.9-7.2,12.2-14.7s-7.2-12.9-14.7-12.2l-88.9,8    c-7.4,0.7-12.9,7.2-12.2,14.7l8,88.9c0.6,7,6.5,12.3,13.4,12.3c0.4,0,0.8,0,1.2-0.1c7.4-0.7,12.9-7.2,12.2-14.7l-4.8-54.1    c36.3,29.4,80.8,46.5,128.3,48.9c3.8,0.2,7.6,0.3,11.3,0.3c55.1,0,107.5-20.2,148.7-57.4    C456.056,357.911,481.656,274.811,462.456,195.511z"></path>
                      </svg>
                      <p>Lade die Seite neu</p>
                  </div>
                  <div class="step">
                      <svg class="icon" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 60">
                          <path d="M30,0C13.458,0,0,13.458,0,30s13.458,30,30,30s30-13.458,30-30S46.542,0,30,0z M30,58C14.561,58,2,45.439,2,30   S14.561,2,30,2s28,12.561,28,28S45.439,58,30,58z"></path>
                          <path d="M30,6c-0.552,0-1,0.447-1,1v23H14c-0.552,0-1,0.447-1,1s0.448,1,1,1h16c0.552,0,1-0.447,1-1V7C31,6.447,30.552,6,30,6z"></path>
                      </svg>
                      <p>Warte ein paar Minuten</p>
              </div>
              </ul>
          </div>
          </div></div>`;
          $(html_container).html(html);
         });
      }
  }

  /* For Soziale Engagement page */
  if ($('body').hasClass('page--soziales-engagement')) { 
        let news_soziales_url = API_URL + "news?sort=-publishDate&filter[isActive]=1&filter[isLightVersion]=true&filter[tag][]=Soziales Engagement";
        let news_soziales_settings = {        
          method: "GET",
          timeout: 0,
          headers: {
            Authorization: Authorization,
            Accept: "application/vnd.api+json",
            "Cache-Control": "max-age=600",
            "Content-Encoding": "application/gzip",
          }
      };

      fetch(news_soziales_url, news_soziales_settings)
      .then(response => {
        // Parse the response as JSON
        return response.json();
      })
      .then(response => {
        // Handle the JSON data      
        var data = response.data;
        if(data != null){          
          var html = '';
          
          html += '<div id="news-container">';
          html += `<div class="grid--4-col-desktop blog__posts articles-wrapper contains-card contains-card--article grid grid--peek grid--2-col-tablet">`;
          html += generateNewsHtml(data);
          if (data.length == 0) {
            html += '<p class="empty-category-text">Es liegen keine Neuigkeiten zum sozialen Engagement vor.</p>';
          }
          html += "</div></div>";
          $("#soziales-engagement-news").html(html);
        }        
      });
  
   }